import script from "./UserTopbar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTopbar.vue?vue&type=script&setup=true&lang=js"

import "./UserTopbar.vue?vue&type=style&index=0&id=64ef6e68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ef6e68"]])

export default __exports__